import { RemoteGetAllPersonOverviewIndicators } from 'data/usecases';
import { GetAllPersonOverviewIndicatorsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPerson } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllPersonOverviewIndicators =
  (): GetAllPersonOverviewIndicatorsUseCaseInterface =>
    new RemoteGetAllPersonOverviewIndicators(
      makeApiUrlPerson(),
      makeAxiosHttpClient(),
    );
